import {
  DASHBOARD_CHANGE_ABD_DATES,
  DASHBOARD_CHANGE_ABD_CASE_ORIGIN,
  DASHBOARD_CHANGE_ABD_PROGRESS,
  DASHBOARD_LOAD_ABD_DATA,
  DASHBOARD_CHANGE_RBD_DATES,
  DASHBOARD_CHANGE_RBD_CASE_ORIGIN,
  DASHBOARD_CHANGE_RBD_PROGRESS,
  DASHBOARD_LOAD_RBD_DATA,
  DASHBOARD_CHANGE_CVM_PROGRESS,
  DASHBOARD_LOAD_CVM_DATA
} from './available'

import moment from 'moment'
import _ from 'lodash'

export default {
  [DASHBOARD_CHANGE_ABD_DATES](state, {fromDate, toDate}) {
    state.dashboard.activityByDate.filters = {
      ...state.dashboard.activityByDate.filters,
      fromDate: fromDate,
      toDate: toDate
    }
  },
  [DASHBOARD_CHANGE_ABD_CASE_ORIGIN](state, originType) {
    state.dashboard.activityByDate.filters = {
      ...state.dashboard.activityByDate.filters,
      originType: originType
    }
  },
  [DASHBOARD_CHANGE_ABD_PROGRESS](state, value) {
    state.dashboard.activityByDate.inProgress = value
  },
  [DASHBOARD_LOAD_ABD_DATA](state, data) {
    let result = {
      labels: [],
      createdByDate: [],
      validatedByDate: []
    }

    for (let date in data) {
      if (!data.hasOwnProperty(date)) {
        continue
      }

      result.labels.push(date)
      const createdCount = _.get(data, [date, 0], 0)
      result.createdByDate.push(createdCount)

      const validatedCount = _.get(data, [date, 1], 0)
      result.validatedByDate.push(validatedCount)

      state.dashboard.activityByDate.data = result
    }
  },
  [DASHBOARD_CHANGE_RBD_DATES](state, {fromDate, toDate}) {
    state.dashboard.reportsByDate.filters = {
      ...state.dashboard.reportsByDate.filters,
      fromDate: fromDate,
      toDate: toDate
    }
  },
  [DASHBOARD_CHANGE_RBD_CASE_ORIGIN](state, originType) {
    state.dashboard.reportsByDate.filters = {
      ...state.dashboard.reportsByDate.filters,
      originType: originType
    }
  },
  [DASHBOARD_CHANGE_RBD_PROGRESS](state, value) {
    state.dashboard.reportsByDate.inProgress = value
  },
  [DASHBOARD_LOAD_RBD_DATA](state, data) {
    let result = {
      labels: [],
      validatedByCreationDate: [],
      overduedByCreationDate: []
    }

    for (let date in data) {
      if (!data.hasOwnProperty(date)) {
        continue
      }

      result.labels.push(date)
      const createdCount = _.get(data, [date, 0], 0)
      result.validatedByCreationDate.push(createdCount)

      const validatedCount = _.get(data, [date, 1], 0)
      result.overduedByCreationDate.push(validatedCount)

      state.dashboard.reportsByDate.data = result
    }
  },
  [DASHBOARD_CHANGE_CVM_PROGRESS](state, value) {
    state.dashboard.casesVsMaterials.inProgress = value
  },
  [DASHBOARD_LOAD_CVM_DATA](state, data) {
    state.dashboard.casesVsMaterials.data = _.orderBy(data, function(item) {
      return moment(item.date).unix()
    }, 'desc')
  }
}



// WEBPACK FOOTER //
// ./src/store/mutations/dashboard.js